import { motion } from "framer-motion";
import { IMAGES } from "@/lib/content";

const SHOTS = [
  { src: IMAGES.heroResidential, label: "Residential Living Room", span: "md:col-span-2 md:row-span-2" },
  { src: IMAGES.upholstery, label: "Upholstery Refresh", span: "" },
  { src: IMAGES.commercial, label: "Commercial Office", span: "" },
  { src: IMAGES.action, label: "Deep Steam Extraction", span: "md:col-span-2" },
  { src: IMAGES.water, label: "Pure-Water Rinse", span: "" },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="label-caps mb-4">Our Work</div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1A2A5E]">
            Results you can see and feel.
          </h2>
          <p className="mt-4 text-[#475569] text-lg">A look at the clean, fresh finish we deliver on every job.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[200px] gap-4">
          {SHOTS.map((s, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
              className={`group relative overflow-hidden rounded-sm border border-[#E2E8F0] ${s.span}`}
            >
              <img src={s.src} alt={s.label} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <span className="absolute bottom-3 left-4 text-white text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                {s.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
